/* Ebora — el chat del asesor. Cuadros Splash.

   Habla con el backend (asesor-ebora/, Cloudflare Worker) por streaming
   NDJSON: los trozos de texto van llegando y se pintan al vuelo, y las
   tarjetas de obra llegan como datos ya verificados por el worker — aquí
   no se decide nada sobre precios ni títulos, solo se pintan.

   La conversación vive en sessionStorage (se conserva al navegar entre
   páginas, muere al cerrar la pestaña): el historial en bruto que pide el
   backend y, aparte, la "vista" ya pintable. Sin URL configurada, el
   widget funciona en MODO DEMO con respuestas de muestra y tarjetas de
   obras reales pedidas a /products/<handle>.js (patrón de favoritos).
*/

(function () {
  var raiz = document.getElementById('cs-asesor');
  if (!raiz) return;

  /* ---------- Configuración y textos ---------- */

  var cfg = {
    url: (raiz.dataset.url || '').replace(/\/+$/, ''),
    whatsapp: raiz.dataset.whatsapp || '',
    contexto: raiz.dataset.ctxHandle
      ? { tipo: raiz.dataset.ctxTipo, handle: raiz.dataset.ctxHandle, titulo: raiz.dataset.ctxTitulo }
      : null,
  };

  var textos = {};
  try {
    textos = JSON.parse(raiz.querySelector('[data-asesor-textos]').textContent);
  } catch (e) {
    return; /* sin textos no hay chat que valga */
  }

  var el = {
    boton: document.getElementById('cs-asesor-abrir'),
    globo: document.getElementById('cs-asesor-globo'),
    globoX: document.getElementById('cs-asesor-globo-x'),
    globoT: document.getElementById('cs-asesor-globo-t'),
    globoB: document.getElementById('cs-asesor-globo-b'),
    panel: document.getElementById('cs-asesor-panel'),
    cerrar: document.getElementById('cs-asesor-cerrar'),
    hilo: document.getElementById('cs-asesor-hilo'),
    chips: document.getElementById('cs-asesor-chips'),
    form: document.getElementById('cs-asesor-form'),
    entrada: document.getElementById('cs-asesor-entrada'),
    enviar: document.getElementById('cs-asesor-enviar'),
    plantillaObra: raiz.querySelector('[data-asesor-plantilla-obra]'),
    plantillaWa: raiz.querySelector('[data-asesor-plantilla-wa]'),
    plantillaIntro: raiz.querySelector('[data-asesor-plantilla-intro]'),
  };

  var CLAVES = {
    historial: 'cs_asesor_historial',
    vista: 'cs_asesor_vista',
    abierto: 'cs_asesor_abierto',
    globo: 'cs_asesor_globo',
    globosSolos: 'cs_asesor_globos_solos',
  };

  var estado = {
    historial: [],
    vista: [],
    ocupado: false,
  };

  function leer(clave, reserva) {
    try {
      var crudo = sessionStorage.getItem(clave);
      return crudo ? JSON.parse(crudo) : reserva;
    } catch (e) {
      return reserva;
    }
  }

  function guardar(clave, valor) {
    try {
      sessionStorage.setItem(clave, JSON.stringify(valor));
    } catch (e) {
      /* navegación privada: el chat funciona, solo que no sobrevive a la página */
    }
  }

  var reduceMovimiento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Pintar ---------- */

  function alFondo(siempre) {
    var cerca = el.hilo.scrollHeight - el.hilo.scrollTop - el.hilo.clientHeight < 120;
    if (siempre || cerca) {
      el.hilo.scrollTo({ top: el.hilo.scrollHeight, behavior: reduceMovimiento ? 'auto' : 'smooth' });
    }
  }

  function formatearEuros(euros) {
    var texto = euros.toFixed(2).replace('.', ',').replace(/,00$/, '');
    return texto + ' €';
  }

  function pintarMensaje(quien, texto) {
    var div = document.createElement('div');
    div.className = 'cs-asesor__msg cs-asesor__msg--' + quien;
    div.textContent = texto;
    el.hilo.appendChild(div);
    return div;
  }

  function pintarError(clave) {
    var div = pintarMensaje('error', textos[clave] || textos.errorGenerico);
    if (cfg.whatsapp) {
      div.appendChild(document.createTextNode(' '));
      var enlace = document.createElement('a');
      enlace.href = cfg.whatsapp;
      enlace.target = '_blank';
      enlace.rel = 'noopener';
      enlace.textContent = 'WhatsApp';
      div.appendChild(enlace);
    }
    alFondo(true);
  }

  /* La última obra de la que se habló, para que el WhatsApp del pie llegue
     al taller con el mensaje ya escrito en vez de en frío. Solo se guarda
     la referencia y la talla: nada de lo que haya escrito el cliente. */
  var ultimaObra = null;

  function recordarObra(obra) {
    ultimaObra = obra;
    var wa = raiz.querySelector('[data-cs-wa]');
    if (!wa || !wa.dataset.base) return;

    var recado = textos.waObra
      .replace('{ref}', obra.ref || obra.titulo || '')
      .replace('{talla}', obra.talla ? ' en ' + obra.talla.nombre : '');

    wa.href = wa.dataset.base + '?text=' + encodeURIComponent(recado);
  }

  function pintarObras(tarjetas, antesDe) {
    var grupo = document.createElement('div');
    grupo.className = 'cs-asesor__obras';

    tarjetas.forEach(function (obra) {
      if (!obra || !obra.handle) return;
      var caja = el.plantillaObra.content.firstElementChild.cloneNode(true);
      var nodo = caja.querySelector('.cs-asesor__obra');
      nodo.href = obra.url || '/products/' + obra.handle;
      var img = nodo.querySelector('.cs-asesor__obra-img');
      img.src = obra.imagen || '';
      img.alt = obra.titulo || '';
      nodo.querySelector('.cs-asesor__obra-t').textContent = obra.titulo || '';
      nodo.querySelector('.cs-asesor__obra-ref').textContent = obra.ref || '';

      /* Con talla recomendada se enseña ESA (su precio, no el "desde"):
         es la que el cliente va a encontrar ya elegida al abrir la ficha,
         así que la tarjeta y la ficha tienen que decir lo mismo. */
      var precio = nodo.querySelector('[data-precio]');
      if (obra.talla && typeof obra.talla.precio === 'number') {
        precio.textContent = obra.talla.nombre + ' · ' + formatearEuros(obra.talla.precio);
      } else if (typeof obra.desde === 'number') {
        precio.textContent = textos.desde + ' ' + formatearEuros(obra.desde);
      } else {
        precio.textContent = '';
      }

      var fav = caja.querySelector('[data-cs-fav]');
      if (fav) fav.dataset.csFav = obra.handle;

      /* Cesta solo con talla recomendada: es la única situación en la que
         sabemos QUÉ variante añadir. */
      var cesta = caja.querySelector('[data-cs-cesta]');
      if (cesta && obra.talla && obra.talla.id) {
        cesta.dataset.csCesta = obra.talla.id;
        cesta.hidden = false;
      }

      grupo.appendChild(caja);
      recordarObra(obra);
    });

    if (!grupo.children.length) return;
    if (antesDe && antesDe.parentNode === el.hilo) {
      el.hilo.insertBefore(grupo, antesDe);
    } else {
      el.hilo.appendChild(grupo);
    }
    /* Forzado: las tarjetas miden mucho y dejarían el resto de la
       respuesta fuera del criterio de "estoy cerca del fondo". */
    alFondo(true);
  }

  /* La burbuja del bot mientras responde: puntos → texto en streaming. */
  function burbujaEnCurso() {
    var div = document.createElement('div');
    div.className = 'cs-asesor__msg cs-asesor__msg--bot';

    var puntos = document.createElement('span');
    puntos.className = 'cs-asesor__puntos';
    puntos.setAttribute('aria-label', textos.pensando);
    puntos.innerHTML = '<span></span><span></span><span></span>';
    div.appendChild(puntos);

    var meta = document.createElement('span');
    meta.className = 'cs-asesor__meta';
    meta.hidden = true;
    div.appendChild(meta);

    var texto = null;
    el.hilo.appendChild(div);
    alFondo(true);

    return {
      nodo: div,
      escribir: function (trozo) {
        if (!texto) {
          texto = document.createElement('span');
          div.insertBefore(texto, puntos);
          puntos.remove();
          meta.remove();
        }
        texto.textContent += trozo;
        alFondo();
      },
      estado: function (mensaje) {
        if (texto) return; /* ya hay respuesta: no pisarla con estados */
        meta.textContent = mensaje;
        meta.hidden = false;
      },
      quitar: function () {
        div.remove();
      },
      vacia: function () {
        return !texto;
      },
    };
  }

  function pintarVista() {
    el.hilo.innerHTML = '';
    /* La presentación va siempre la primera: sin ella, el hilo vacío del
       móvil era un saludo y medio panel en blanco. */
    if (el.plantillaIntro) el.hilo.appendChild(el.plantillaIntro.content.firstElementChild.cloneNode(true));
    estado.vista.forEach(function (pieza) {
      if (pieza.q === 'obras') pintarObras(pieza.v);
      else if (pieza.q === 'wa') quizaBotonWhatsApp('whatsapp');
      else pintarMensaje(pieza.q, pieza.t);
    });
    el.chips.hidden = estado.vista.some(function (p) {
      return p.q === 'cliente';
    });
    alFondo(true);
  }

  function apuntar(pieza) {
    estado.vista.push(pieza);
    guardar(CLAVES.vista, estado.vista);
  }

  /* ---------- Añadir a la cesta ---------- */

  /* OJO (trampa 3 del proyecto): el endpoint con la API de carrito es
     `/cart/add.js`, con el `.js`. `routes.cart_add_url` de Liquid apunta a
     `/cart/add` a secas, que devuelve una página, no JSON. */
  function anadirALaCesta(boton) {
    var id = boton.dataset.csCesta;
    if (!id || boton.disabled) return;

    var etiqueta = boton.querySelector('[data-cs-cesta-txt]');
    boton.disabled = true;
    etiqueta.textContent = textos.anadiendo;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cesta');
        return r.json();
      })
      .then(function () {
        boton.classList.add('esta-dentro');
        etiqueta.textContent = textos.anadido;
        actualizarContadorCesta();

        /* Se transforma en enlace a la cesta: quien acaba de añadir algo
           normalmente quiere ver qué lleva, y si no, sigue hablando. */
        window.setTimeout(function () {
          etiqueta.textContent = textos.verCesta;
          boton.disabled = false;
          boton.dataset.csCesta = '';
          boton.addEventListener('click', function () {
            window.location.href = '/cart';
          });
        }, 1400);
      })
      .catch(function () {
        boton.disabled = false;
        etiqueta.textContent = textos.anadir;
        pintarError('errorCesta');
      });
  }

  /* Se le pide a Shopify que vuelva a pintar la sección del icono del
     carrito y se sustituye entera, que es como lo hace el propio Dawn
     (ver cart-drawer.js y cart-notification.js).

     No vale con escribir el número a mano: cuando el carrito está VACÍO,
     Dawn no dibuja la burbuja en absoluto, así que no hay nada que
     actualizar — hay que traerse el marcado nuevo. Y tampoco se puede ir a
     por `.cart-count-bubble` a ciegas: el contador de favoritos reutiliza
     esa misma clase a propósito (trampa 17), y se le estaría escribiendo
     encima el número del carrito. */
  function actualizarContadorCesta() {
    fetch('/?sections=cart-icon-bubble', { headers: { accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (secciones) {
        if (!secciones || !secciones['cart-icon-bubble']) return;
        var destino = document.getElementById('cart-icon-bubble');
        if (!destino) return;
        /* Shopify devuelve la sección envuelta en `#shopify-section-<id>`,
           no en el id del elemento de la página: hay que ir a por
           `.shopify-section` y quedarse con su interior, que es
           exactamente lo que hace Dawn en cart.js y cart-notification.js. */
        var doc = new DOMParser().parseFromString(secciones['cart-icon-bubble'], 'text/html');
        var origen = doc.querySelector('.shopify-section');
        if (origen) destino.innerHTML = origen.innerHTML;
      })
      .catch(function () {
        /* el contador se pondrá al día solo en la siguiente página */
      });
  }

  el.hilo.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-cs-cesta]');
    if (boton && boton.dataset.csCesta) anadirALaCesta(boton);
  });

  /* ---------- El botón de WhatsApp cuando Ebora deriva ---------- */

  /* Si la respuesta acaba mandando a hablar con una persona, no basta con
     decirlo: se pone el botón, con el recado de la última obra ya escrito.
     Se decide aquí y no en el servidor porque el texto llega en trozos y
     hasta el final no se sabe si mencionó WhatsApp. */
  function esDerivacion(texto) {
    var t = (texto || '').toLowerCase();
    return t.indexOf('whatsapp') >= 0 || t.indexOf('wa.me') >= 0;
  }

  function quizaBotonWhatsApp(texto, dondeVa) {
    if (!cfg.whatsapp || !el.plantillaWa) return;
    if (!esDerivacion(texto)) return;

    var wa = raiz.querySelector('[data-cs-wa]');
    var nodo = el.plantillaWa.content.firstElementChild.cloneNode(true);
    nodo.href = (wa && wa.href) || cfg.whatsapp;
    nodo.querySelector('[data-cs-wa-boton-txt]').textContent = textos.waBoton;

    if (dondeVa && dondeVa.parentNode === el.hilo) {
      el.hilo.insertBefore(nodo, dondeVa.nextSibling);
    } else {
      el.hilo.appendChild(nodo);
    }
    alFondo(true);
  }

  /* ---------- Abrir y cerrar ---------- */

  function bloquearFondo(bloquear) {
    if (window.innerWidth >= 750) return;
    document.documentElement.style.overflow = bloquear ? 'hidden' : '';
  }

  /* En un móvil o una tableta, poner el foco en la casilla al abrir saca el
     teclado de golpe y tapa media conversación antes de que dé tiempo a
     leer nada. Ahí el foco va al panel (se anuncia igual a quien usa lector
     de pantalla) y el teclado sale solo cuando se toca la casilla. */
  var tactil = window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  /* Con el teclado abierto, la parte visible de la pantalla encoge pero el
     panel, pegado a los cuatro bordes, no se entera: la casilla y los
     últimos mensajes quedaban debajo del teclado. El panel se ajusta al
     trozo que de verdad se ve (visualViewport), y vuelve a su sitio al
     cerrarse el teclado. Solo por debajo de 750, donde el panel ocupa la
     pantalla entera. */
  var visible = window.visualViewport;
  function ajustarAlTeclado() {
    if (!visible || el.panel.hidden || window.innerWidth >= 750) {
      el.panel.style.height = '';
      el.panel.style.top = '';
      return;
    }
    el.panel.style.height = Math.round(visible.height) + 'px';
    el.panel.style.top = Math.round(visible.offsetTop) + 'px';
    /* Escribiendo, lo último de la conversación tiene que quedar a la vista
       justo encima de la casilla. */
    if (document.activeElement === el.entrada) alFondo(true);
  }
  if (visible) {
    visible.addEventListener('resize', ajustarAlTeclado);
    visible.addEventListener('scroll', ajustarAlTeclado);
  }

  function abrir(sinAnimar) {
    raiz.classList.toggle('cs-asesor--sin-animar', !!sinAnimar);
    raiz.setAttribute('data-abierto', '');
    el.panel.hidden = false;
    el.boton.setAttribute('aria-expanded', 'true');
    esconderGlobo(false);
    bloquearFondo(true);
    guardar(CLAVES.abierto, true);
    if (!sinAnimar) {
      if (tactil) el.panel.focus({ preventScroll: true });
      else el.entrada.focus();
    }
    ajustarAlTeclado();
    alFondo(true);
  }

  function cerrar(sinFoco) {
    raiz.removeAttribute('data-abierto');
    el.panel.hidden = true;
    el.boton.setAttribute('aria-expanded', 'false');
    bloquearFondo(false);
    guardar(CLAVES.abierto, false);
    ajustarAlTeclado();
    if (!sinFoco) el.boton.focus();
  }

  /* Al pinchar una obra que ha recomendado Ebora, el chat se cierra y se
     queda cerrado en la página siguiente: se va a ver el cuadro, y con el
     panel abierto encima no se veía (en el móvil lo tapaba entero). La
     conversación no se pierde: el botón de Ebora la vuelve a abrir tal
     cual. Si el enlace se abre en otra pestaña, el chat sigue donde está. */
  el.hilo.addEventListener('click', function (e) {
    var enlace = e.target.closest && e.target.closest('a[href]');
    if (!enlace || !el.hilo.contains(enlace)) return;
    if (enlace.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    cerrar(true);
  });

  el.boton.addEventListener('click', function () {
    abrir(false);
  });
  el.cerrar.addEventListener('click', function () {
    cerrar();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !el.panel.hidden) cerrar();
  });

  /* Trampa de foco sencilla: Tab se queda dando vueltas dentro del panel. */
  el.panel.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var focables = el.panel.querySelectorAll('button, a[href], textarea');
    if (!focables.length) return;
    var primero = focables[0];
    var ultimo = focables[focables.length - 1];
    if (e.shiftKey && document.activeElement === primero) {
      e.preventDefault();
      ultimo.focus();
    } else if (!e.shiftKey && document.activeElement === ultimo) {
      e.preventDefault();
      primero.focus();
    }
  });

  /* ---------- El bocadillo ----------

     Un mensaje corto encima del botón que cambia según dónde está el
     cliente y según lo que ya le haya preguntado a Ebora (pedido por
     Gabriel el 24 sep 2026). En una ficha que Ebora le recomendó, se lo
     recuerda; en una colección, se ofrece a buscar ahí lo que pidió; sin
     conversación, una invitación que cuadra con la página. Sus opciones
     abren el chat y mandan la pregunta ya escrita.

     Para que no canse: sale a los 7 s, se va solo a los 16 s, la X lo
     calla el resto de la visita, y si se ha ido solo cuatro veces sin que
     nadie lo toque, deja de salir. Nunca en la cesta ni en las páginas que
     ya tienen a Ebora dentro (el probador) o en las que no pinta nada. */

  var globo = textos.globo || {};
  var urlProbador = raiz.dataset.probador || '';
  var ESPERA_GLOBO = 7000;
  var DURA_GLOBO = 16000;
  var MAX_GLOBOS_SOLOS = 4;
  var relojGlobo = null;

  function hayConversacion() {
    return estado.vista.some(function (p) {
      return p.q === 'cliente';
    });
  }

  function yaRecomendada(handle) {
    return estado.vista.some(function (p) {
      return p.q === 'obras' && (p.v || []).some(function (o) {
        return o && o.handle === handle;
      });
    });
  }

  function mensajeDelGlobo() {
    var ruta = location.pathname;
    if (/^\/(cart|checkout|account|policies)/.test(ruta)) return null;
    if (/^\/pages\//.test(ruta)) return null;

    var ctx = cfg.contexto;
    var probar = ctx && ctx.tipo === 'obra' && urlProbador
      ? { txt: globo.pared, href: urlProbador + '?obra=' + encodeURIComponent(ctx.handle) }
      : null;

    if (hayConversacion()) {
      if (ctx && ctx.tipo === 'obra') {
        if (yaRecomendada(ctx.handle)) {
          return { t: globo.recomendada, op: [{ txt: globo.talla, q: globo.tallaSeguirQ }, probar] };
        }
        return { t: globo.sigueObra, op: [{ txt: globo.encaja, q: globo.encajaQ }] };
      }
      if (ctx && ctx.tipo === 'coleccion') {
        return { t: globo.sigueColeccion, op: [{ txt: globo.buscaAqui, q: globo.buscaAquiQ }] };
      }
      return { t: globo.sigue, op: [{ txt: globo.mas, q: globo.masQ }] };
    }

    if (ctx && ctx.tipo === 'obra') {
      return { t: globo.obra, op: [{ txt: globo.talla, q: globo.tallaQ }, probar] };
    }
    if (ctx && ctx.tipo === 'coleccion') {
      return { t: globo.coleccion, op: [{ txt: globo.ayudame, q: globo.ayudameQ }] };
    }
    if (ruta === '/') {
      return { t: globo.inicio, op: [{ txt: globo.salon, q: globo.salonQ }, { txt: globo.dormitorio, q: globo.dormitorioQ }] };
    }
    if (ruta.indexOf('/search') === 0) {
      return { t: globo.busqueda, op: [{ txt: globo.pedir }] };
    }
    return null;
  }

  function esconderGlobo(recordar) {
    clearTimeout(relojGlobo);
    el.globo.hidden = true;
    if (recordar) guardar(CLAVES.globo, true);
  }

  function mostrarGlobo() {
    if (!el.panel.hidden || leer(CLAVES.globo, false)) return;
    if (leer(CLAVES.globosSolos, 0) >= MAX_GLOBOS_SOLOS) return;
    var m = mensajeDelGlobo();
    if (!m || !m.t) return;

    el.globoT.textContent = m.t;
    el.globoB.innerHTML = '';
    m.op.filter(function (o) {
      return o && o.txt;
    }).forEach(function (o, i) {
      var op = document.createElement(o.href ? 'a' : 'button');
      op.className = 'cs-asesor__globo-op' + (i === 0 ? ' cs-asesor__globo-op--prim' : '');
      op.textContent = o.txt;
      if (o.href) {
        op.href = o.href;
      } else {
        op.type = 'button';
        op.addEventListener('click', function () {
          esconderGlobo(false);
          abrir(false);
          if (o.q && !estado.ocupado) mandar(o.q, null);
        });
      }
      el.globoB.appendChild(op);
    });

    el.globo.hidden = false;
    relojGlobo = setTimeout(function () {
      esconderGlobo(false);
      guardar(CLAVES.globosSolos, leer(CLAVES.globosSolos, 0) + 1);
    }, DURA_GLOBO);
  }

  el.globoX.addEventListener('click', function () {
    esconderGlobo(true);
  });

  el.globoT.addEventListener('click', function () {
    esconderGlobo(false);
    abrir(false);
  });

  /* Quien toca el bocadillo ya sabe que Ebora está ahí: se le vuelve a
     ofrecer en las páginas siguientes aunque antes se le fueran solos. */
  el.globo.addEventListener('click', function (e) {
    if (e.target !== el.globoX) guardar(CLAVES.globosSolos, 0);
  });

  if (!leer(CLAVES.abierto, false)) setTimeout(mostrarGlobo, ESPERA_GLOBO);

  /* ---------- Escribir ---------- */

  el.entrada.addEventListener('input', function () {
    el.entrada.style.height = 'auto';
    el.entrada.style.height = Math.min(el.entrada.scrollHeight, 96) + 'px';
  });

  el.entrada.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      el.form.requestSubmit();
    }
  });

  el.form.addEventListener('submit', function (e) {
    e.preventDefault();
    var texto = el.entrada.value.trim();
    if (!texto || estado.ocupado) return;
    el.entrada.value = '';
    el.entrada.style.height = 'auto';
    mandar(texto, null);
  });

  el.chips.addEventListener('click', function (e) {
    var chip = e.target.closest('.cs-asesor__chip');
    if (!chip || estado.ocupado) return;
    mandar(chip.textContent.trim(), chip.dataset.demo);
  });

  function mandar(texto, claveDemo) {
    apuntar({ q: 'cliente', t: texto });
    pintarMensaje('cliente', texto);
    el.chips.hidden = true;
    alFondo(true);

    if (!cfg.url) {
      responderDemo(claveDemo);
    } else {
      conversar(texto);
    }
  }

  /* ---------- Conversación real (streaming NDJSON) ---------- */

  function procesarLinea(linea, marco) {
    var evento;
    try {
      evento = JSON.parse(linea);
    } catch (e) {
      return;
    }

    if (evento.t === 'texto') {
      marco.burbuja.escribir(evento.v);
      marco.acumulado += evento.v;
    } else if (evento.t === 'obras') {
      pintarObras(evento.v, marco.burbuja.nodo);
      apuntar({ q: 'obras', v: evento.v });
    } else if (evento.t === 'estado') {
      marco.burbuja.estado(textos.buscando);
    } else if (evento.t === 'historial') {
      estado.historial = evento.v;
      guardar(CLAVES.historial, estado.historial);
    } else if (evento.t === 'error') {
      marco.fallo = evento.v === 'saturado' ? 'errorSaturado' : evento.v === 'limite' ? 'errorLimite' : 'errorGenerico';
    }
  }

  function conversar(texto) {
    estado.ocupado = true;
    el.enviar.disabled = true;

    var marco = { burbuja: burbujaEnCurso(), acumulado: '', fallo: null };

    fetch(cfg.url + '/chat', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        historial: estado.historial,
        mensaje: texto,
        contexto: cfg.contexto,
      }),
    })
      .then(function (respuesta) {
        if (respuesta.status === 429) throw new Error('errorRitmo');
        if (!respuesta.ok) throw new Error('errorGenerico');

        if (!respuesta.body || !respuesta.body.getReader) {
          /* navegador sin streaming: se lee entero y se procesa igual */
          return respuesta.text().then(function (todo) {
            todo.split('\n').forEach(function (l) {
              if (l.trim()) procesarLinea(l, marco);
            });
          });
        }

        var lector = respuesta.body.getReader();
        var decodificador = new TextDecoder();
        var resto = '';

        function siguiente() {
          return lector.read().then(function (paso) {
            if (paso.done) {
              if (resto.trim()) procesarLinea(resto, marco);
              return;
            }
            resto += decodificador.decode(paso.value, { stream: true });
            var lineas = resto.split('\n');
            resto = lineas.pop();
            lineas.forEach(function (l) {
              if (l.trim()) procesarLinea(l, marco);
            });
            return siguiente();
          });
        }

        return siguiente();
      })
      .then(function () {
        if (marco.fallo) throw new Error(marco.fallo);
        if (marco.acumulado) {
          apuntar({ q: 'bot', t: marco.acumulado });
          if (esDerivacion(marco.acumulado)) {
            apuntar({ q: 'wa' });
            quizaBotonWhatsApp(marco.acumulado, marco.burbuja.nodo);
          }
        } else {
          marco.burbuja.quitar();
        }
      })
      .catch(function (error) {
        if (marco.burbuja.vacia()) marco.burbuja.quitar();
        else if (marco.acumulado) apuntar({ q: 'bot', t: marco.acumulado });
        var clave = ['errorRitmo', 'errorSaturado', 'errorLimite', 'errorGenerico'].indexOf(error.message) >= 0
          ? error.message
          : 'errorGenerico';
        pintarError(clave);
        apuntar({ q: 'error', t: textos[clave] || textos.errorGenerico });
      })
      .then(function () {
        estado.ocupado = false;
        el.enviar.disabled = false;
      });
  }

  /* ---------- Modo demo (URL sin configurar) ---------- */

  var DEMO = {
    salon: {
      t: 'Para un salón suele ir bien un cuadro de 100 cm de ancho o más. Aquí tienes tres estilos distintos.',
      obras: ['cuadro-abstracto-rojo-ocre-vanguardista', 'cuadro-abstracto-con-menina-colorida', 'cuadro-abstracto-de-menina-moderna'],
    },
    menina: {
      t: 'Las Meninas son el sello de la casa: 236 versiones modernas. Mira estas dos.',
      obras: ['cuadro-abstracto-con-menina-colorida', 'cuadro-abstracto-de-menina-moderna'],
    },
    gel: {
      t: 'Son pinceladas de gel transparente aplicadas a mano sobre la impresión: le dan relieve de pintura real. Se añade desde la ficha y cuesta de 27 a 189 € según piezas y tamaño.',
    },
    envio: {
      t: 'Solo enviamos dentro de España, con tarifa plana: península, 12 €; Baleares, 30 €, y Canarias, Ceuta y Melilla, 70 €.',
    },
  };

  function responderDemo(clave) {
    estado.ocupado = true;
    el.enviar.disabled = true;
    var burbuja = burbujaEnCurso();
    var guion = clave && DEMO[clave] ? DEMO[clave] : { t: textos.demoAviso };

    setTimeout(function () {
      var listas = Promise.resolve([]);
      if (guion.obras) {
        listas = Promise.all(
          guion.obras.map(function (handle) {
            return fetch('/products/' + handle + '.js')
              .then(function (r) {
                return r.ok ? r.json() : null;
              })
              .catch(function () {
                return null;
              });
          })
        );
      }

      listas.then(function (productos) {
        var tarjetas = (productos || []).filter(Boolean).map(function (p) {
          var precios = (p.variants || []).map(function (v) {
            return v.price;
          });
          return {
            handle: p.handle,
            titulo: p.title,
            ref: p.variants && p.variants[0] && p.variants[0].sku ? p.variants[0].sku.split('-')[0] : '',
            desde: precios.length ? Math.min.apply(null, precios) / 100 : null,
            imagen: (p.featured_image || '').split('?')[0] + '?width=360',
            url: '/products/' + p.handle,
          };
        });

        if (tarjetas.length) {
          pintarObras(tarjetas, burbuja.nodo);
          apuntar({ q: 'obras', v: tarjetas });
        }
        burbuja.escribir(guion.t);
        apuntar({ q: 'bot', t: guion.t });
        estado.ocupado = false;
        el.enviar.disabled = false;
      });
    }, 900);
  }

  /* ---------- Arranque ---------- */

  estado.historial = leer(CLAVES.historial, []);
  estado.vista = leer(CLAVES.vista, []);

  if (!estado.vista.length) {
    estado.vista = [{ q: 'bot', t: textos.saludo }];
    guardar(CLAVES.vista, estado.vista);
  }

  pintarVista();

  if (leer(CLAVES.abierto, false)) abrir(true);
})();
